import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../theme'

const styles: IStyles = {
    notification: {
        display: 'flex'
    },
    errorText: {
        marginLeft: 20,
        lineHeight: 1.4
    },
    toastClassName: {
        padding: '20px !important',
        backgroundColor: `${colors.errorSaturated} !important`,
        color: `${colors.white} !important`,
        fontSize: 16,
    },
    button: {
        marginTop: 12,
    },
}

addStyles(styles)
export default styles
